




























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getHigherExam, getHigherAreaAndSubjects } from '../../models/api'

@Component({})
export default class HigherExam extends Vue {
  private examTypes = []
  private typeValue = null
  private years = []
  private yearValue = null
  private subjects = []
  private usages = []
  private usagesValue = null

  private get userInfo() {
    return this.$store.state.user_info
  }

  public get moduleName() {
    return this.$route.meta.label
  }

  public get paperType(): any {
    return this.examTypes.find((n) => this.typeValue === n[0])
  }

  @Watch('userInfo', { deep: true })
  onUserChange(val, old) {
    this.renderPage()
  }

  mounted() {
    this.renderPage()
  }

  public async renderPage() {
    if (!this.userInfo) return
    const arr = Object.keys(this.userInfo)
    if (!(arr && arr.length > 0)) return
    const { data, success }: any = await getHigherExam({})

    if (success) {
      this.examTypes = data.paper_types_choices
      this.years = data.year_choices
      this.typeValue = this.examTypes[0][0]
      this.yearValue = this.years[0][0]
      await this.renderAreaAndSubjects(this.typeValue, this.yearValue)
    }
  }

  public async renderAreaAndSubjects(paper_type, year) {
    const { data, success }: any = await getHigherAreaAndSubjects({ paper_type, year })

    if (success) {
      this.subjects = data.subjects
      this.usages = data.usages
    }
  }

  public async changeType(type) {
    console.log(type)
    this.typeValue = type
    await this.renderAreaAndSubjects(type, this.yearValue)
  }

  public async changeYear(year) {
    this.yearValue = year
    await this.renderAreaAndSubjects(this.typeValue, year)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '年份',
      value: year,
      paper_type: this.paperType && this.paperType[1]
    })
  }

  public trackAnchor(itm) {
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '名称',
      value: itm[1],
      paper_type: this.paperType && this.paperType[1]
    })
  }

  public trackAnchor2(itm) {
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '试卷导航',
      value: itm[1],
      paper_type: this.paperType && this.paperType[1]
    })
  }

  public showList(s) {
    const { paper_ids } = s
    const ids = paper_ids.join(',')

    // this.$router.push(`/senior/list?ids=${ids}`)
    window.open(`/senior/list?ids=${ids}`)
  }
}
